import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ServicesComponent } from './pages/services/services.component';
import { ResultsComponent } from './pages/results/results.component';
import { BookingComponent } from './pages/booking/booking.component';
import { AdminComponent } from './pages/admin/admin.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'ATR Automotive Detailing' },
  { path: 'services', component: ServicesComponent, title: 'Services | ATR Detailing' },
  { path: 'results', component: ResultsComponent, title: 'Results | ATR Detailing' },
  { path: 'book', component: BookingComponent, title: 'Contact | ATR Detailing' },
  { path: 'admin', component: AdminComponent, title: 'Admin | ATR Detailing' },
  { path: '**', redirectTo: '' },
];
